import {
    CommandResponse,
    FolderSection,
    PlacementPayload,
    RevisionedCommandResponse,
    StudyEntityType,
    toFolderSection,
} from '@faro/study-designer-model';
import axios from 'axios';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { StudyPathParameter } from '../parameter';

const factory = createStudyEntityHookFactory<FolderSection>(StudyEntityType.FolderSection);

export const useFolderSections = factory.list(
    (
        { studyId, ...query }: StudyPathParameter & { revision?: number },
        signal?: AbortSignal
    ): Promise<FolderSection[]> => {
        return axios
            .get(`/api/study-designer/studies/${studyId}/folder-section`, {
                signal,
                params: query,
            })
            .then(response => response.data?.map(toFolderSection) ?? []);
    }
);

export const useFolderSectionUpdate = factory.mutate(
    (entity: FolderSection): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .put(`/api/study-designer/studies/${entity.studyId}/folder-section/${entity.id}`, entity)
            .then(response => response.data);
    },
    {
        optimisticUpdate: (folderSection, optimisticData) => {
            return optimisticData.map(x => (x.id === folderSection.id ? folderSection : x));
        },
    }
);

export const useFolderSectionDelete = factory.mutate(
    (entity: { id: string; studyId: string }): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .delete(`/api/study-designer/studies/${entity.studyId}/folder-section/${entity.id}`)
            .then(response => response.data);
    }
);

export const useFolderSectionMove = factory.mutate(
    (entity: {
        id: string;
        studyId: string;
        placement: PlacementPayload;
    }): Promise<RevisionedCommandResponse<CommandResponse>> => {
        const { id, studyId, placement } = entity;
        return axios
            .put(`/api/study-designer/studies/${studyId}/folder-section/${id}/actions/move`, placement)
            .then(response => response.data);
    }
);
